import React from 'react'
import { TextField } from '@material-ui/core'
import { Autocomplete } from '@material-ui/lab'

const ProjectSelection = ({ options, setOption, currentOption }) => {
  return <div>
    <Autocomplete
      fullWidth
      disableClearable
      size='small'
      value={currentOption}
      onChange={(e, part) => setOption(part)}
      options={options}
      getOptionLabel={(option) => option}
      renderInput={(params) => <TextField label="Project" {...params} variant="outlined" />}
    />
  </div>
}

export default ProjectSelection;
